/**
 * "Nice" value-axis ticks for a bar chart: 0 … top in steps of 1 / 2 / 5 ×
 * 10ⁿ, aiming for about `target` intervals, with `top ≥ max` so the longest
 * bar never runs past the axis (15 → 0, 5, 10, 15; 143 → 0, 50, 100, 150).
 * Integer steps by default (task counts): a max of 1 reads 0, 1 — never 0.5.
 * An all-zero / missing max still gets an axis (0, 1).
 *
 * Kept in its own module (not Charts.jsx) so the chart file only exports
 * components — otherwise React Fast Refresh / HMR breaks for it.
 */
export function niceTicks(max, { target = 4, integer = true } = {}) {
  const m = Number(max)
  if (!Number.isFinite(m) || m <= 0) return [0, 1]
  const raw = m / target
  const pow = 10 ** Math.floor(Math.log10(raw))
  let step = [1, 2, 5, 10].map((f) => f * pow).find((s) => s >= raw)
  if (integer) step = Math.max(1, Math.round(step))
  const top = Math.ceil(m / step) * step
  const ticks = []
  for (let i = 0; i * step <= top; i++) {
    ticks.push(Math.round(i * step * 1e6) / 1e6)
  }
  return ticks
}
